import { LeaderboardEntryType } from "context/state";
import computeValues from "./computeValues";

export default function extractValues(props: LeaderboardEntryType) {
  const { userTokens, userNftTokens } = props;
  const BUSD = userTokens.find(
    ({ identifier }) => identifier === "BUSD-f2c46d",
  );
  const MEX = userTokens.find(({ identifier }) => identifier === "MEX-ec32fa");
  const EGLDBUSD = userTokens.find(
    ({ identifier }) => identifier === "EGLDBUSD-ba3816",
  );

  const LKMEX = computeValues(userNftTokens, "LKMEX-d1c4ab");

  const EGLDMEX = computeValues(userNftTokens, "EGLDMEX-56b111");

  const MEXFARM = computeValues(userNftTokens, "MEXFARM-b93e60");
  const EGLDMEXF = computeValues(userNftTokens, "EGLDMEXF-f1e9f7");
  const EGLDBUSDF = computeValues(userNftTokens, "EGLDBUSDF-0f9d6f");
  return { BUSD, MEX, EGLDBUSD, LKMEX, EGLDMEX, MEXFARM, EGLDMEXF, EGLDBUSDF };
}
